import history from '../routes/history'
import gaUtils from '../components/GAWrapper'

history.listen((location) => {
  gaUtils.trackPageView(location)
})

gaUtils.initGa(history)

